<template>
<div>
  <section class="content">
    <div class="box info-box">
      <div class="box-header with-border">
        Search By
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
            <div class="form-group">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" v-on:input="loadStaff" placeholder="Select Branch"></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Employee ID <span class="red">*</span></label>
              <v-select v-model="staff" name="employee_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getRecordByEmployee">

              </v-select>
              <has-error
                :form="form"
                field="agent_id"
              ></has-error>
            </div>
          </div>
          <div class="col-md-3">
            <label for="date">Date</label>
            <input type="date" v-model="form.date" name="date" @change="changeFilter(1)" class="form-control" placeholder="Date">
          </div>
        </div>
      </div>
      <!-- /.box-body -->
    </div>
    <!-- Default box -->
    <div class="info-box"  v-if="canAccess('employee-Leave-view-any')">
      <div class="box-header with-border">
        <h3 class="box-title">Attendance List</h3>
        
        <div class="box-tools">
          <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('employee-Leave-create')">
            <i class="fa fa-plus"></i> Add New
          </button>
        </div>

      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-sm-6 col-xs-6">
            <label>
              <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <div class="col-sm-6 col-xs-6">
            <div class="input-group pull-right input-group-sm" style="width: 150px;">
              <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

              <div class="input-group-btn">
                <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
        <table class="table table-sm table-bordered table-hover">
          <thead style="background-color: #d6dddd;">
            <tr>
              <th class="hidden-xs">Sr. No.</th>
              <th>Name</th>
              <th class="hidden-xs">Mobile</th>
              <th class="hidden-xs">Date</th>
              <th class="hidden-xs">Remark</th>
              <!-- <th>Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows.data" :key="index">
              <td class="hidden-xs">{{ (index + pagination.from) }}</td>
              <td><i v-if="row.employee">{{ row.employee.name }} ({{ row.employee.code}})</i></td>
              <td class="hidden-xs"><i v-if="row.employee">{{ row.employee.mobile }}</i></td>
              <td class="hidden-xs">{{row.date | myDate}}</td>
              <td class="hidden-xs">{{row.remark}}</td>
              <!-- <td>
                <div class="btn-group">
                  <button
                    v-if="canAccess('employee-Leave-update')"
                    @click="editModal(row)"
                    class="btn btn-success btn-xs"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                </div>
              </td> -->
            </tr>
          </tbody>
        </table>
              
      </div>
      <!-- /.box-body -->
      <div class="box-footer clearfix" v-if="pagination.current_page > 0">
        <div class="row">
          <div class="col-sm-4">
            Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
          </div>
          <div class="col-sm-8">
            <ul class="pagination pagination-sm no-margin pull-right">
              <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
              <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

              <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
              <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
              <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
              <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
              <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
              <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
              <li><a href="#">...</a></li>
              
              <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
              <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
              <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
              <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

              <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
              <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
      <!-- /.box -->
  </section>    
  <div class="modal fade" id="newModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 v-show="!editMode" class="modal-title">Add New</h4>
          <h4 v-show="editMode" class="modal-title">Update</h4>
          
        </div>
        <form @submit.prevent="editMode ? updateAbsent() : createAbsent()">
          <div class="modal-body">
            <!-- general form elements disabled -->
            <div class="card card-warning">
              <!-- /.card-header -->
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <!-- text input -->

                    <div class="form-group">
                      <label for="Branch">Branch</label>
                      <v-select v-model="branch" name="branch_id" label="name" :options="branches" v-on:input="loadStaff" placeholder="Select Branch"></v-select>
                      <has-error
                        :form="form"
                        field="branch_id"
                      ></has-error>
                    </div>
                    <div class="form-group">
                        <label>Employee ID <span class="red">*</span></label>
                        <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getEmployeeDetails">

                        </v-select>
                        <has-error
                        :form="form"
                        field="agent_id"
                        ></has-error>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Enter Date <span class="red">*</span></label>
                      <input
                        type="date"
                        v-model="form.date"
                        name="date"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('date') }"
                      />

                        <has-error :form="form" field="date"></has-error>
                    </div>
                    <div class="form-group">
                      <label for="remark">Remark</label>
                      <input
                        type="text"
                        v-model="form.remark"
                        name="remark"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('remark') }"
                      />

                      <has-error :form="form" field="remark"></has-error>
                    </div>
                    <div class="form-group">
                      <label
                        >Select Status <span class="red">*</span></label
                      >
                      <select
                        v-model="form.status"
                        name="status"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('status'),
                        }"
                      >
                        <option v-if="!form.status" selected value="">
                          Select Status
                        </option>
                        <option value="active">Active</option>
                        <option value="inActive">Inactive</option>
                      </select>
                      <has-error :form="form" field="status"></has-error>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <div class="modal-footer text-center">
            <button
              v-show="!editMode"
              type="submit"
              class="btn btn-success"
            >
              CREATE
            </button>
            <button v-show="editMode" type="submit" class="btn btn-success">
              UPDATE
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CANCEL
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->   
</div>
</template>

<script>
export default {
  name: 'EmployeeAttendance',
  data () {
    return {
      staffs: [],
      staff: {},
      branches: [],
      branch: {},
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      form: new Form({
        id: '',
        employee_id: '',
        remark: '',
        date: '',
        status: ''
      }),
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      // $('#newModal').modal('show')
    },

    createAbsent () {
      this.$axios
        .post('absent', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Absent Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      // this.$axios
      //   .post('bank', this.form, {
      //     headers: { Authorization: 'Bearer ' + localStorage.token }
      //   })
      //   .then(() => {
      //     Fire.$emit('AfterCreate')
      //     $('#newModal').modal('hide')
      //     Toast.fire({
      //       icon: 'success',
      //       title: 'Bank Added Successfully'
      //     })
      //   })
      //   .catch(
      //     function (error) {
      //       Toast.fire({ icon: 'error', title: 'Please Try Again' })
      //       this.form.errors.errors = error.response.data.error
      //     }.bind(this)
      //   )
    },

    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      // $('#newModal').modal('show')
      this.form.fill(row)
    },
    updateBank () {
      // console.log('update data')

      this.$axios
        .put('bank/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Bank Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getEmployeeDetails () {
      this.form.employee_id = this.staff.user_id
    },
    getRecordByEmployee () {
      this.form.employee_id = this.staff.user_id
      this.changeFilter(1)
    },
    loadStaff () {
      this.form.branch_id = this.branch.id
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.agent_id === item.user.id) {
              this.staff = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'absent'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.form.employee_id) {
        pageUrl += `&employee_id=${this.form.employee_id}`
      }
      if (this.form.date) {
        pageUrl += `&date=${this.form.date}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.$axios
    //     .get('bank?all=all', {
    //       headers: { Authorization: 'Bearer ' + localStorage.token }
    //     })
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //     })
    //     .catch(function (error) {
    //       Swal.fire({
    //         icon: 'error',
    //         title: 'Oops...',
    //         text: error
    //       })
    //     })
    // }
  },

  created () {
    this.loadBranch()
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// EmployeeAttendance.vue?6bffb8d6